import React, { Component, createRef, Fragment } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomDialog from "../common/Dialog";
import AddVehicleModal from "./addVehicle";
import Table from "../common/tableWithBackEndPagination";
import isEqual from "react-fast-compare";
import { checkPrivileges, errorHandler } from "../../Helpers";
import ConfirmDialoag from "../common/ConfirmDialoag";
import VehicleFilerModal from "./VehicleFilterModal";
// import DevicePortList from './devicePortList'
import Button from "../common/Button";
import { CircularProgress, Grid, Popover } from "@mui/material";
import TextField from "../common/TextField";
import Style from "style-it";
import moment from "moment";
import instance from "../../axios";
import ExportImportMenu from "../common/ExportImportMenu";

// import {
//   removedvehicle,
//   updatevehicle,
//   addvehicle,
// } from "../../Actions/Vehicles";
import Loader from "../../Layout/Loader";

import { ViewUserDetail } from "./Components/viewUnitDetail";
// import Table1 from "../../Components/common/TableServices";
import Table1 from "../../Components/common/TableWithColors";
import EnhancedTable from "./TableServices";
import { CSVLink } from "react-csv";
import ArchivedVehiclesTable from "./ArchivedVehiclesTable";
import SingleSelect from "../common/SingleSelect";
import CitySelector from "./CitySelector";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import UserAccessVehicle from "./UserAccessVehicle";
import MulkiyaModal from "./MulkiyaModal";
import {
  decodeFileUrl,
  downloadUserFile,
} from "../Users/addUserForm/FormHelpers";
//
const toAttrString = (value, fallback = "0") => {
  if (value === 0 || value === "0") return "0";
  if (value === undefined || value === null || value === "") return fallback;
  return String(value);
};

const vehicleDataFormat = (data, itemId, user, loginUser) => ({
  id: itemId ? itemId : 0,
  attributes: {
    ...data.attributes,
    insurancePercentage: toAttrString(data.attributes?.insurancePercentage),
    bankPercentage: toAttrString(data.attributes?.bankPercentage),
    Maintenance: toAttrString(data.attributes?.Maintenance),
    zakatPercentage: toAttrString(data.attributes?.zakatPercentage),
    resalePercentage: toAttrString(data.attributes?.resalePercentage),
    replacement: toAttrString(data.attributes?.replacement),
    chassisNumber: toAttrString(data.attributes?.chassisNumber, ""),
    standByVehicle: toAttrString(data.attributes?.standByVehicle),
    capacity: data?.attributes?.capacity || "0",
    createdBy: loginUser?.id || 0,
  },
  deviceId: data?.deviceId?.id || "",
  label: data.label,
  modelId: data?.modelId?.id || "",
  fuelEfficiency: data.fuelEfficiency ? parseFloat(data.fuelEfficiency) : 0,
  odometer: data.odometer ? parseFloat(data.odometer) : 0,
  garage: data.garage,
  entitlement: data.entitlement ? parseFloat(data.entitlement) : 0,
  // vehicleType: data.vehicleType,
  vin: data.vin,
  vehicleLicensePlate: data.vehicleLicensePlate,
  leasePeriod: data && data.leasePeriod ? parseInt(data.leasePeriod) : "",
  vehicleLisencePlateArabic: data.vehicleLisencePlateArabic,
  totalAvailablekm: data.totalAvailablekm
    ? parseFloat(data.totalAvailablekm)
    : 200,
  expirationTime: data.expirationTime,
  complianceTime: data.complianceTime,
  insuranceTime: data.insuranceTime,
  monthlyRate: data && data.monthlyRate ? parseFloat(data.monthlyRate) : "",
  purchasePrice:
    data && data.purchasePrice ? parseFloat(data.purchasePrice) : "",
  purchaseDate: data?.purchaseDate || "",
  deliveryDate: data?.deliveryDate || "",
  leaseEndDate: data?.leaseEndDate || "",
  leaseStartDate: data?.leaseStartDate || "",
  areaId: data && data.areaId ? data.areaId.id : "",
  cityId: data && data?.cityId ? data?.cityId?.id : 1,
  category: data && data.category ? data.category : "",
  imei: data && data.imei ? data.imei : "",
  unitIcon: data && data.unitIcon ? data.unitIcon : "",
  onLease: data && data.onLease ? data.onLease : false,
  parentId:
    data && data.parentId
      ? data.parentId
      : user && (user.accountAdminId || user.value)
        ? user.accountAdminId || user.value
        : user && user.id
          ? user.id
          : 0,
  carbonFootPrint: data && data.carbonFootPrint ? data.carbonFootPrint : 0,
  url: data?.url || "",
  // parentId:user && user.id?user.id : 0
});

const trasmissionList = [
  { name: "Manual", key: "manual" },
  { name: "Automatic", key: "automatic" },
];
const fuel_typeList = [
  { name: "PETROL", key: "PETROL" },
  { name: "DIESEL", key: "DIESEL" },
  { name: "ETHANOL", key: "ETHANOL" },
  { name: "BIODIESEL", key: "BIODIESEL" },
  { name: "CNG", key: "CNG" },
  { name: "LPG", key: "LPG" },
  { name: "HYDROGEN", key: "HYDROGEN" },
  { name: "HYBRID", key: "HYBRID" },
  { name: "PHEV", key: "PHEV" },
  { name: "ELECTRIC", key: "ELECTRIC" },
  { name: "OTHERS", key: "OTHERS" },
];

const VIN_BODY_TYPE_ALIASES = {
  "sedan/saloon": "Sedan",
  saloon: "Sedan",
  "station wagon": "Wagon",
  wagon: "Wagon",
  "sport utility vehicle": "SUV",
  suv: "SUV",
  "multi-purpose vehicle": "MPV",
  mpv: "MPV",
  pickup: "Pickup",
  truck: "Truck",
  hatchback: "Hatchback",
  coupe: "Coupe",
  convertible: "Convertible",
  van: "Van",
};

const parseVinDecoderResponse = (responseData) => {
  if (!responseData || typeof responseData !== "object") return null;
  if (responseData.statusCode === "400") return null;
  if (responseData.data && typeof responseData.data === "object") {
    return responseData.data;
  }
  if (responseData.vin || responseData.maker) {
    return responseData;
  }
  return null;
};

const resolveVinCategory = (bodyType, categories = []) => {
  if (!bodyType) return "";
  const normalized = String(bodyType).trim();
  const alias = VIN_BODY_TYPE_ALIASES[normalized.toLowerCase()] || normalized;

  if (!Array.isArray(categories) || !categories.length) {
    return alias;
  }

  const exact = categories.find(
    (c) => String(c).toLowerCase() === alias.toLowerCase(),
  );
  if (exact) return exact;

  const partial = categories.find((c) => {
    const categoryValue = String(c).toLowerCase();
    const aliasValue = alias.toLowerCase();
    return (
      categoryValue.includes(aliasValue) || aliasValue.includes(categoryValue)
    );
  });

  return partial || alias;
};

const normalizeVinFuelType = (fuelType) => {
  if (!fuelType) return "";
  const value = String(fuelType).trim().toLowerCase();
  if (value.includes("diesel")) return "DIESEL";
  if (value.includes("electric") || value === "bev") return "ELECTRIC";
  if (value.includes("plug") || value === "phev") return "PHEV";
  if (value.includes("hybrid")) return "HYBRID";
  if (value.includes("ethanol")) return "ETHANOL";
  if (value.includes("biodiesel")) return "BIODIESEL";
  if (value === "lpg") return "LPG";
  if (value === "cng") return "CNG";
  if (value.includes("hydrogen")) return "HYDROGEN";
  if (
    value.includes("gasoline") ||
    value.includes("petrol") ||
    value.includes("gas")
  ) {
    return "PETROL";
  }
  return String(fuelType).toUpperCase();
};

const normalizeVinTransmission = (transmission) => {
  if (!transmission) return "";
  const value = String(transmission).trim().toLowerCase();
  if (value.includes("manual")) return "manual";
  if (
    value.includes("automatic") ||
    value.includes("auto") ||
    value.includes("cvt") ||
    value.includes("semi")
  ) {
    return "automatic";
  }
  return String(transmission).toLowerCase();
};

const formDefault = {
  label: "",
  garage: "",
  model: "",
  // vehicleType: "",
  expirationTime: "",
  vehicleLicensePlate: "",
  vehicleLisencePlateArabic: "",
  totalAvailablekm: 200,
  leasePeriod: "",
  onLease: false,
  fuelEfficiency: "",
  category: "",
  imei: "",
  unitIcon: "",
  attributes: {
    typeName: ["Maintenance"],
    country: "United Arab Emirates Dirham",
  }, //vehicleLicensePlate: ''
  carbonFootPrint: 0,
  odometer: 0,
  entitlement: 0,
  url: "",
  uploadFile: null,
};
let source;
let cachedTags = null;
let fuel_type = "";
class vehicleList extends Component {
  constructor(props) {
    super(props);
    this.controllerRef = createRef();
    const navEditVehicle = props.location?.state?.editVehicle;
    this.state = {
      openingNavEdit: !!navEditVehicle,
      navEditVehicle: navEditVehicle || null,
      addOption: false,
      editOption: false,
      vehiclesData: "",
      page: 1,
      pageSize: 20,
      form: { ...formDefault },
      trasmissionList: trasmissionList,
      fuel_typeList: fuel_typeList,
      selectedVehicle: "",
      // addOption: false,
      // editOption: false,
      isVisableTrackerModal: false,
      isVisableUserBtn: false,
      isVin: false,
      vehicleId: "",
      vehicleTracker: "",
      // form: { ...formDefault },
      vehicleStatus: "",
      allMakes: [],
      makesLoading: false,
      trackerData: "",
      selectedMakeTypes: "",
      onDeleteConfirmation: false,
      onDataSendConfirmation: false,
      itemSearch: "",
      searchContractText: "",
      areas: "",
      defaultAccountsList: "",
      selectedUser: "",
      categories: [],
      deviceCategories: [],
      selecteditem: "",
      loader1: false,
      showImportedInvoiceError: false,
      selectedUserCheck: false,
      tagSearch: false,
      alltags: {},
      open: true,
      tag_1: "",
      tag_2: "",
      tag_3: "",
      tag_4: "",
      tag_5: "",
      enableReset: false,
      vehicleLicensePlateError: false,
      allVehiclesValid: false,
      isImportBtnDisabled: true,
      rowsPerPage: 10,
      isVehicleStatus: false,
      vinError: true,

      validVehicles: [],
      inValidVehicles: [],
      uploadedVehicles: [],
      duplicateLicensePlate: [],
      duplicateVin: [],
      vehicleStatusButton: "all",
      vehicleUploadPageSize: 10,
      vehicleUploadPage: 0,
      yearError: false,
      showHistoryVehicles: false,
      vehicleHistoryData: null,
      vehicleHistoryPage: 1,
      vehicleHistoryPageSize: 50,
      selectHistoryVehicleId: null,
      isVehicleDnsModalOpen: false,
      selectedVehicleId: null,
      isLoadingVehicleDns: false,
      vehicleDns: {
        data: [],
        page: 1,
        pageSize: 10,
        total: 0,
      },
      submitForm: false,
      vehicleFilesData: [],
      newVehicleId: "",
      showVinConfirmDialog: false,
      pendingVinVehicleData: null,
      mulkiyaVehicle: null,
      mulkiyaAutoPrint: false,

      // minPercentage: 1,
      // maxPercentage: 100,
      // categoriesList: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeUser = this.handleChangeUser.bind(this);

    this.handleChangeForAttributesValues =
      this.handleChangeForAttributesValues.bind(this);
    this.handleChangeLicenseExpDate =
      this.handleChangeLicenseExpDate.bind(this);
    this.makesPagination = {
      page: 1,
      search: "",
      hasNext: false,
      loading: false,
    };
    this.makesSearchTimer = null;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateVehicle = this.updateVehicle.bind(this);
    // this.removeEnable = this.removeEnable.bind(this);
    // this.deleteVehicle = this.deleteVehicle.bind(this);
  }

  componentWillMount() {
    this.getMoreUsers();
    const navEditVehicle =
      this.props.location?.state?.editVehicle || this.state.navEditVehicle;
    if (navEditVehicle) {
      this.openEditVehicleFromNavigation();
      return;
    }
    const defaultCityIds = this.props.userCities?.map((c) => c.id) || [];
    this.setState({ cityIds: defaultCityIds }, () => {
      this.getVehivlesList({}, true);
    });
  }

  componentDidUpdate(prevProps) {
    const editVehicle = this.props.location?.state?.editVehicle;
    const prevEdit = prevProps.location?.state?.editVehicle;
    if (editVehicle && editVehicle !== prevEdit) {
      this.setState(
        { openingNavEdit: true, navEditVehicle: editVehicle },
        this.openEditVehicleFromNavigation,
      );
    }
  }

  openEditVehicleFromNavigation = async () => {
    if (this._navEditInProgress) return;
    const editVehicle =
      this.props.location?.state?.editVehicle || this.state.navEditVehicle;
    if (!editVehicle || this.state.editOption) return;

    this._returnTo = this.props.location?.state?.returnTo || null;
    this._navEditInProgress = true;
    try {
      await this.onEdit(editVehicle);
      this.setState({ openingNavEdit: false, navEditVehicle: null });
      if (this.props.navigate) {
        this.props.navigate(this.props.location.pathname, {
          replace: true,
          state: {},
        });
      }
    } finally {
      this._navEditInProgress = false;
    }
  };
  resetVehicleValidation = () => {
    this.setState({
      vehicleLicensePlateError: false,
    });
  };
  enableUpdateButton = () => {
    this.setState({
      isVisableUserBtn: false,
    });
  };
  // downloadMakeModelList = () => {
  //   const filePath = '/assets/MakeModelList.txt';
  //   // Construct the full URL to the file
  //   const fileUrl = process.env.PUBLIC_URL + filePath;
  //   // Create a link element
  //   const link = document.createElement('a');
  //   // Set the href attribute to the file URL
  //   link.href = fileUrl;
  //   // Specify that the link should download the file
  //   link.setAttribute('download', '');
  //   // Append the link to the document body
  //   document.body.appendChild(link);
  //   // Trigger a click on the link to start the download
  //   link.click();
  //   // Remove the link from the document body
  //   document.body.removeChild(link);
  // };
  openModale = () => {
    this.fetchCategories();
    this.fetchDeviceCategories();
    this.getDevicesList();
    this.fetchMake();
    this.getAreas();
    // this.getFuelEfficiency();
    // this.getMoreUsers();
    this.setState({
      addOption: true,
      editOption: false,
      isVisableUserBtn: false,
      form: { ...formDefault },
      vehicleFilesData: [],
    });
  };

  onEdit = async (items) => {
    await Promise.all([
      this.fetchCategories(),
      this.fetchDeviceCategories(),
      this.getDevicesList(),
      this.fetchMake(),
      this.getAreas(),
    ]);
    let fuelEfficiency;

    let item = items;

    if (item) {
      const [z, device] = await Promise.all([
        this.fetchSelectedModel(item.modelId),
        item.deviceId !== 0 ? this.fetchDevice(item.deviceId) : "",
      ]);
      if (item.category) {
        fuelEfficiency = await this.getFuelEfficiency(item.category);
      }
      const selectedCity =
        typeof item.cityId === "object"
          ? item.cityId
          : this.props.cities?.find((city) => city.id == item.cityId) || null;
      const isOwnerOrAuthorized =
        item.parentId === this.props.logInUser.id ||
        (Array.isArray(this.state.defaultAccountsList) &&
          this.state.defaultAccountsList.some(
            (owner) => owner.userId === item.parentId,
          ));

      this.setState(
        {
          form: {
            ...item,
            modelId: z && z.id ? { id: z.id, label: z.modelName } : "",
            make:
              z && z.id
                ? { id: z.makeName, key: z.makeName, label: z.makeName }
                : "",
            cityId: selectedCity,
            deviceId:
              device && device.id
                ? { id: device.id, key: device.id, label: device.name }
                : "",
            uploadFile: null,
            url: item?.url || "",
          },
          fuelEfficiency: item.fuelEfficiency
            ? item.fuelEfficiency
            : fuelEfficiency || "",
          selectedVehicle: item,
          fetchModelId: true,
          editOption: true,
          addOption: false,
          selectedUserCheck: isOwnerOrAuthorized ? true : false,
          vinError: !(
            item?.vin?.replace(/\s/g, "")?.length === 17 &&
            /^[A-Za-z0-9]{17}$/.test(item?.vin?.replace(/\s/g, "") || "")
          ),

          isVin:
            item?.vin?.replace(/\s/g, "")?.length === 17 &&
            /^[A-Za-z0-9]{17}$/.test(item?.vin?.replace(/\s/g, "") || ""),
        },
        () => this.fetchVehicleFiles(item?.id),
      );
    }
  };

  replaceHtmlEntities = (text) => {
    let itemname = text.replace(/amp;/, " ").replace(/amp;/g, "");
    const textarea = document.createElement("textarea");
    textarea.innerHTML = itemname;
    return textarea.value;
  };

  getMoreUsers = () => {
    fetch(`/api/accounts/listuseraccountslimiteddata?page=1&limit=-1`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        response.json().then((res) => {
          if (res.status === "success") {
            let data = res.data;
            console.log("Data", data);
            // const transformedUsers = users.map((user) => ({
            //   name: user.entity.name,
            //   email: user.entity.email,
            //   e: user.entity.e,
            // }));

            if (data.total === 0) {
              this.setState({
                resultMessage: "No option found",
                defaultOptions: "",
              });
            } else {
              let result = data?.data || [];
              const updateResult = result.map((item) => ({
                ...item,
                label: item.accountName,
                value: item.accountAdminId,
                key: item.accountName,
              }));
              this.setState({
                resultMessage: "",
                defaultAccountsList: updateResult,
              });
            }
          } else if (res?.statusCode === "440") {
            window.location.replace("/login");
          } else if (res.statusCode) {
            var err = res?.message.split(":");
            err[1] = err[1].replace(")", "");

            toast.error(this.props.translate(err[1]));
          } else {
            throw response;
          }
        });
      })
      .catch((e) => {
        console.log("e =", e);
        //   this.props.dispatch(toast.error({
        //   message: 'somethingWentWrong',
        //   autoDismiss: 5
        // }))
      });
  };

  onCloseImportedModal = () => {
    this.setState({
      showImportedInvoiceError: false,
      showRegeneratedModal: false,
      // bulkInvoicesDate: "",
    });
  };

  fetchCategories = () => {
    fetch(`/api/vehiclecategorys/get?page=1&limit=500&category=`)
      .then((response) => {
        if (response.ok) {
          response.json().then((res) => {
            if (res.status === "success") {
              const raw = res.data?.data ?? res.data ?? [];
              const list = Array.isArray(raw) ? raw : [];
              const categories = list
                .map((item) =>
                  typeof item === "string" ? item : item?.categoryName,
                )
                .filter(Boolean);
              this.setState({ categories });
            } else if (res?.statusCode === "440") {
              window.location.replace("/login");
            } else if (res.statusCode) {
              var err = res?.message.split(":");
              err[1] = err[1].replace(")", "");

              toast.error(this.props.translate(err[1]));
            }
          });
        }
      })
      .catch((e) => {
        console.log("e =", e);
      });
  };

  fetchDeviceCategories = () => {
    fetch(`/api/devices/categories`)
      .then((response) => {
        if (response.ok) {
          response.json().then((res) => {
            if (res.status === "success") {
              this.setState({
                deviceCategories: res.data?.categories || [],
              });
            } else if (res?.statusCode === "440") {
              window.location.replace("/login");
            } else if (res.statusCode) {
              var err = res?.message.split(":");
              err[1] = err[1].replace(")", "");

              toast.error(this.props.translate(err[1]));
            }
          });
        }
      })
      .catch((e) => {
        console.log("e =", e);
      });
  };

  getDevicesList = async () => {
    try {
      if (!this.props.logInUser) return;

      const response = await axios.get(
        `/api/devices/list?limit=50&userId=${this.props.logInUser?.id}`,
      );

      this.setState({
        trackerData: response?.data?.data?.data || [],
      });
    } catch (error) {
      console.error("Error fetching devices list:", error);
      this.setState({
        trackerData: [],
      });
    }
  };

  fetchVehicleFiles = async (vehicleId) => {
    if (!vehicleId) {
      this.setState({ vehicleFilesData: [] });
      return;
    }
    try {
      const files = await instance.get(
        `/api/uploads/get?entityId=${vehicleId}&entity=Vehicle`,
      );
      this.setState({
        vehicleFilesData: Array.isArray(files) ? files : files?.data || [],
      });
    } catch (error) {
      this.setState({ vehicleFilesData: [] });
    }
  };

  handleVehicleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error(
        this.props.translate("fileSize5MB") ||
          "File size must be less than 5MB",
      );
      e.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const fileData = event.target.result;
      const uploadFile = {
        name: file.name,
        contentType: file.type,
        oldUrl: this.state.form?.url || "",
        entity: "Vehicle",
        entityId: this.state.selectedVehicle?.id || 0,
        data: String(fileData).split("base64,")[1],
      };
      this.setState({
        form: {
          ...this.state.form,
          uploadFile,
        },
      },()=>{
        this.checkRequiredFields()
      });
    };
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  removeVehicleFile = () => {
    this.setState({
      form: {
        ...this.state.form,
        uploadFile: null,
        url: "",
      },
    });
  };

  removeVehicleSavedFile = async (mediaId) => {
    try {
      await instance.delete(`/api/uploads/${mediaId}`);
      const vehicleId = this.state.selectedVehicle?.id;
      await this.fetchVehicleFiles(vehicleId);
      if (!this.state.form?.uploadFile) {
        this.setState({
          form: {
            ...this.state.form,
            url: "",
          },
        });
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  downloadVehicleFile = (event, data) => {
    const fileData = data || {
      url: this.state.form?.url,
      fileName:
        this.state.form?.uploadFile?.name ||
        decodeFileUrl(this.state.form?.url || "")
          .split("/")
          .pop() ||
        "download",
    };
    if (!fileData?.url) return;
    downloadUserFile(event, {
      url: fileData.url,
      fileName: fileData.fileName || fileData.name || "download",
    });
  };

  resolveVehicleUploadUrl = async (form, entityId = 0) => {
    if (form?.uploadFile?.data) {
      const uploadRes = await instance.post(
        "/api/uploads",
        {
          ...form.uploadFile,
          entity: "Vehicle",
          entityId: entityId || form.uploadFile.entityId || 0,
          oldUrl: form.url || form.uploadFile.oldUrl || "",
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      );
      return uploadRes?.url || "";
    }
    return form?.url || "";
  };

  updateVehicle = async () => {
    // event.preventDefault();
    let { selectedVehicle, form } = this.state;
    try {
      const url = await this.resolveVehicleUploadUrl(form, selectedVehicle.id);
      const obj = vehicleDataFormat(
        { ...form, url },
        selectedVehicle.id,
        this.state.selectedUser,
        this.props.logInUser,
      );

      const result = await axios.put(
        `/api/vehicles/${selectedVehicle.id}`,
        obj,
      );

      if (result.data.status === "success") {
        this.setState({
          addOption: false,
          editOption: false,
          isVisableUserBtn: false,
          selectedUser: "",
          form: "",
        });

        toast.success(this.props.translate("Vehicle Updated"));
        this.getVehivlesList();
      } else {
        toast.error(
          this.props.translate(result?.data?.message || "Something went wrong"),
        );
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  handleChangeLicenseExpDate = (name) => (event) => {
    // if (name === 'expirationTime') {
    const dateValue = event ? event.toISOString() : null;

    this.setState(
      {
        form: {
          ...this.state.form,
          [name]: dateValue,
        },
      },
      () => this.checkRequiredFields(),
    );
  };

  mapMakeToOption = (item) => ({
    id: item.id,
    key: item.makeName,
    label: item.makeName,
    value: item.makeName,
  });

  fetchMakesPage = async (page = 1, search = "") => {
    const data = await instance({
      method: "GET",
      url: `/api/makes/get?page=${page}&limit=20&make=${encodeURIComponent(search)}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const list = Array.isArray(data?.data) ? data.data : [];
    const total = parseInt(data?.total, 10) || 0;
    const hasNext = Boolean(data?.hasNext ?? total > page * 20);
    return {
      options: list.map(this.mapMakeToOption),
      hasNext,
    };
  };

  fetchMake = async () => {
    try {
      this.setState({ makesLoading: true });
      const { options, hasNext } = await this.fetchMakesPage(1, "");
      this.makesPagination = { page: 1, search: "", hasNext, loading: false };
      this.setState({ allMakes: options, makesLoading: false });
    } catch (error) {
      errorHandler(error, this.props.dispatch);
      this.setState({ allMakes: [], makesLoading: false });
    }
  };

  searchMakesList = (search = "") => {
    if (this.makesSearchTimer) {
      clearTimeout(this.makesSearchTimer);
    }
    this.makesSearchTimer = setTimeout(async () => {
      try {
        this.setState({ makesLoading: true });
        const { options, hasNext } = await this.fetchMakesPage(1, search);
        this.makesPagination = { page: 1, search, hasNext, loading: false };
        this.setState({ allMakes: options, makesLoading: false });
      } catch (error) {
        errorHandler(error, this.props.dispatch);
        this.setState({ allMakes: [], makesLoading: false });
      }
    }, 300);
  };

  loadMoreMakes = async () => {
    const pag = this.makesPagination || {};
    if (!pag.hasNext || pag.loading) return;

    this.makesPagination.loading = true;
    this.setState({ makesLoading: true });

    try {
      const nextPage = pag.page + 1;
      const { options, hasNext } = await this.fetchMakesPage(
        nextPage,
        pag.search,
      );
      const merged = [...(this.state.allMakes || []), ...options];
      this.makesPagination = {
        page: nextPage,
        search: pag.search,
        hasNext,
        loading: false,
      };
      this.setState({ allMakes: merged, makesLoading: false });
    } catch (error) {
      this.makesPagination.loading = false;
      this.setState({ makesLoading: false });
      errorHandler(error, this.props.dispatch);
    }
  };

  async fetchVehicleMake(selectedMake) {
    return await instance({
      method: "GET",
      url: `/api/models/get?limit=1000&make=${selectedMake}&search= `,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        let defaultOptions =
          response &&
          response.data &&
          response.data.map((item) => {
            return { ...item, label: item.modelName };
          });
        return defaultOptions;
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
      });
  }

  handleChange1 = async (name, event) => {
    if (name === "trasmissionType") {
      this.setState(
        {
          form: {
            ...this.state.form,
            attributes: { ...this.state.form.attributes, [name]: event.id },
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "make") {
      const z = await this.fetchVehicleMake(event.label);
      this.setState(
        {
          selectedMakeTypes: z,
          form: {
            ...this.state.form,
            [name]: event,
            modelId: {},
            attributes: { ...this.state.form.attributes, make: event.label },
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "modelId") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: event,
            attributes: {
              ...this.state.form.attributes,
              model: event.modelName,
            },
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "deviceId") {
      this.setState({
        form: {
          ...this.state.form,
          [name]: event,
        },
      });
    }
  };

  handleChangeForAttributesValues = async (name, event, link) => {
    let { attributes } = this.state.form;
    if (name === "year") {
      const year = event.target.value;
      this.setState(
        {
          form: {
            ...this.state.form,
            attributes: {
              ...this.state.form.attributes,
              [name]: year,
            },
          },
        },
        () => {
          const currentYear = new Date().getFullYear(); // keep it as a number
          const parsedYear = parseInt(year, 10);
          const parsedMinYear = 1950;
          if (parsedYear >= parsedMinYear && parsedYear <= currentYear + 1) {
            this.setState(
              {
                yearError: false,
              },
              () => {
                this.checkRequiredFields();
              },
            );
          } else {
            this.setState(
              {
                yearError: true,
              },
              () => {
                this.checkRequiredFields();
              },
            );
          }
          this.checkRequiredFields();
        },
      );
    } else if (name === "type") {
      this.setState({
        form: {
          ...this.state.form,
          attributes: {
            ...this.state.form.attributes,
            [name]: event.target.checked,
          },
        },
      });
    } else if (name === "make") {
      const z = await this.fetchVehicleMake(event.label);
      this.setState(
        {
          selectedMakeTypes: z,
          form: {
            ...this.state.form,
            [name]: event,
            modelId: {},
            attributes: { ...this.state.form.attributes, make: event.label },
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "modelId") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: event,
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "areaId") {
      this.setState({
        form: {
          ...this.state.form,
          [name]: event,
        },
      });
    } else if (name === "cityId") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: event,
          },
        },
        () => {
          this.checkRequiredFields();
        },
      );
    } else if (name === "searchUnits") {
      this.setState({
        form: {
          ...this.state.form,
          [name]: event.target.value,
        },
      });
    } else {
      const target = name === "trasmissionType" ? event : event && event.target;
      let value =
        name === "trasmissionType" ? event : target && target.value.toString();

      const persistAsStringKeys = [
        "bankPercentage",
        "Maintenance",
        "zakatPercentage",
        "resalePercentage",
        "replacement",
        "chassisNumber",
        "standByVehicle",
        "insurancePercentage",
      ];

      if (persistAsStringKeys.includes(name)) {
        const percentageKeys = [
          "insurancePercentage",
          "bankPercentage",
          "resalePercentage",
          "replacement",
          "zakatPercentage",
        ];
        let strValue =
          value === undefined || value === null ? "" : String(value).trim();

        if (percentageKeys.includes(name) && strValue !== "") {
          let num = parseFloat(strValue);
          if (!Number.isNaN(num)) {
            if (num > 100) num = 100;
            if (num < 0) num = 0;
            strValue = String(num);
          }
        }

        // Keep key in attributes; 0 / empty numeric fields persist as "0"
        if (strValue === "" || strValue === "NaN") {
          strValue = name === "chassisNumber" ? "" : "0";
        }

        attributes[name] = strValue;
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes: { ...attributes },
            },
          },
          () => {
            if (this.state.editOption) {
              this.setState({
                isVisableUserBtn: true,
              });
            }
          },
        );
      } else if (value) {
        if (
          name === "otherCost" ||
          name === "fines" ||
          name === "brandingCost" ||
          name === "telematicsCost" ||
          name === "depreciationCost" ||
          name === "driverCost"
        ) {
          attributes[name] = parseFloat(value);
        } else attributes[name] = event.target.value;
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes: { ...attributes },
            },
          },
          () => {
            if (this.state.editOption) {
              this.setState({
                isVisableUserBtn: true,
              });
            }
          },
        );
      } else {
        delete attributes[name];
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes: { ...attributes },
            },
          },
          () => {
            if (this.state.editOption) {
              this.setState({
                isVisableUserBtn: true,
                waslLinked: false,
              });
            }
          },
        );
      }
    }
  };

  handleChangeUser = (name, event) => {
    if (name === "owner") {
      this.setState({
        owner: event,
      });
    } else {
      this.setState(
        {
          selectedUser: event,
        },
        () => {
          this.checkRequiredFields();
        },
      );
    }
  };

  // Cities API may return "s*"/"s+" instead of "\s*"/"\s+" for whitespace.
  normalizeCityPlateRegex = (regexStr) => {
    if (!regexStr) return "";
    return String(regexStr).replace(/(^|[^\\])s([*+])/g, (_, before, quant) => {
      return before + "\\s" + quant;
    });
  };

  isValidLicensePlate = (plate, city) => {
    if (!plate || !String(plate).trim()) return false;
    const plateValue = String(plate).trim();
    const validLicensePlateFormatArabic =
      /^[\u0621-\u064A]\s[\u0621-\u064A]\s[\u0621-\u064A]\s[\d٠-٩]{4}$/;
    if (validLicensePlateFormatArabic.test(plateValue)) {
      return true;
    }

    const selectedCity =
      city && typeof city === "object"
        ? city
        : (this.props.cities || []).find(
            (c) => String(c.id) === String(city),
          ) || null;

    if (!selectedCity?.regex) {
      return false;
    }

    try {
      const pattern = this.normalizeCityPlateRegex(selectedCity.regex);
      return new RegExp(pattern).test(plateValue);
    } catch (e) {
      return false;
    }
  };

  checkRequiredFields() {
    let {
      label,
      vehicleLicensePlate,
      deliveryDate,
      leaseEndDate,
      leaseStartDate,
      onLease,
      make,
      modelId,
      vin,
      category,
      totalAvailablekm,
      cityId,
    } = this.state.form;
    let { fuel_type, year } = this.state.form.attributes;
    let userType = this.props.logInUser?.userType;
    let value = true;
    if (this.state.editOption) {
      value = !isEqual(this.state.form, this.props.selecteditem);
    }

    const plateValid = this.isValidLicensePlate(vehicleLicensePlate, cityId);
    if (plateValid) {
      this.setState({
        vehicleLicensePlateError: false,
      });
    } else {
      this.setState({
        vehicleLicensePlateError: true,
      });
    }
    const hasMake = Boolean(make && (make.id || make.key || make.label));
    const hasModel = Boolean(modelId && modelId.id);

    if (onLease) {
      if (
        label &&
        label.trim().length &&
        vehicleLicensePlate &&
        vehicleLicensePlate.trim().length &&
        plateValid &&
        cityId &&
        deliveryDate &&
        leaseEndDate &&
        leaseEndDate > leaseStartDate &&
        value &&
        hasMake &&
        hasModel &&
        vin &&
        this.state.isVin &&
        category &&
        fuel_type &&
        year &&
        !this.state.yearError &&
        totalAvailablekm &&
        totalAvailablekm > 1
      ) {
        this.setState({
          isVisableUserBtn: true,
        });
      } else {
        this.setState({
          isVisableUserBtn: false,
        });
      }
    } else {
      if (
        label &&
        label.trim().length &&
        vehicleLicensePlate &&
        vehicleLicensePlate.trim().length &&
        plateValid &&
        cityId &&
        // fuel_type !== '' &&
        // fuel_type !== undefined &&
        // deliveryDate &&
        // leaseEndDate&&
        // leaseEndDate > leaseStartDate &&
        value &&
        hasMake &&
        hasModel &&
        vin &&
        this.state.isVin &&
        year &&
        !this.state.yearError &&
        category &&
        fuel_type &&
        totalAvailablekm &&
        totalAvailablekm > 0 &&
        (![4, 5, 6].includes(userType) ||
          (this.state.selectedUser && this.state.selectedUser !== ""))
      ) {
        this.setState({
          isVisableUserBtn: true,
        });
      } else {
        this.setState({
          isVisableUserBtn: false,
        });
      }
    }
  }
  handleChange(name, event) {
    const { target } = event;
    if (target && target.type === "checkbox") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: target.checked,
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "fuel_type") {
      // fuel_type = event.name;
      this.setState(
        {
          form: {
            ...this.state.form,
            attributes: { ...this.state.form.attributes, [name]: event.id },
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "category") {
      let value = target.value;
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: value,
          },
        },
        () => {
          this.checkRequiredFields();
          this.getFuelEfficiency(value);
        },
      );
    } else if (name === "areaId") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: event,
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "cityId") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: event,
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "typeName") {
      this.setState(
        {
          form: {
            ...this.state.form,
            attributes: {
              ...this.state.form.attributes,
              typeName: event,
            },
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "entitlement") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: target.value,
          },
        },
        () => this.checkRequiredFields(),
      );
    } else {
      let value = target.value.toString();
      if (name === "vin") {
        const trimmedValue = value.replace(/\s/g, "").slice(0, 17);
        const isVinValid =
          trimmedValue.length === 17 && /^[A-Za-z0-9]{17}$/.test(trimmedValue);

        this.setState(
          {
            form: {
              ...this.state.form,
              [name]: trimmedValue,
            },
            vinError: isVinValid
              ? ""
              : "VIN must be exactly 17 alphanumeric characters.",
            isVin: isVinValid,
          },
          () => this.checkRequiredFields(),
        );
      } else {
        this.setState(
          {
            form: {
              ...this.state.form,
              [name]: value,
            },
          },
          () => this.checkRequiredFields(),
        );
      }
    }
  }
  onChangedDevice = (name, item) => {
    if (item) {
      const device = this.props?.devices?.data?.find((d) => d.id === item.id);

      this.setState(
        {
          vehicleTracker: {
            value: device.id,
            label: device.name,
            uniqueId: device.uniqueId,
          },
          form: {
            ...this.state.form,
            deviceId: item.value,
          },
        },
        () => this.checkRequiredFields(),
      );
    } else {
      this.setState(
        {
          vehicleTracker: "",
          form: {
            ...this.state.form,
            deviceId: "",
          },
        },
        () => this.checkRequiredFields(),
      );
    }
  };
  modalControle = () => {
    const returnTo = this._returnTo;
    this._returnTo = null;
    if (returnTo && this.props.navigate) {
      this.setState({
        addOption: false,
        editOption: false,
        form: "",
        openingNavEdit: false,
        showVinConfirmDialog: false,
        pendingVinVehicleData: null,
      });
      this.props.navigate(returnTo);
      return;
    }

    const shouldLoadList = !this.state.vehiclesData?.data?.length;
    this.setState(
      {
        addOption: false,
        editOption: false,
        form: "",
        vehicleFilesData: [],
        showVinConfirmDialog: false,
        pendingVinVehicleData: null,
      },
      () => {
        if (shouldLoadList) {
          const defaultCityIds = this.props.userCities?.map((c) => c.id) || [];
          this.setState({ cityIds: defaultCityIds }, () => {
            this.getVehivlesList({}, true);
          });
        }
      },
    );
  };

  async fetchDevice(id) {
    return await instance({
      method: "GET",
      url: `/api/devices/${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
      });
  }

  async fetchSelectedModel(id) {
    return await instance({
      method: "GET",
      url: `/api/models?modelId=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response[0];
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
      });
  }

  async fetchSelectedUser(id) {
    return await instance({
      method: "GET",
      url: `/api/users/${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
      });
  }

  //  async getFuelEfficiency  (type) {
  //   return await instance({
  //      method: 'GET',
  //      url: `/api/vehicles/fuelefficiency?type=${type}`,
  //      headers: {
  //        Accept: 'application/json',
  //        'Content-Type': 'application/json'
  //      }
  //    })
  //      .then(response => {
  //       this.setState({
  //         form: {
  //         ...this.state.form,
  //           fuelEfficiency: "",
  //       },})
  //        return response
  //      })
  //      .catch(error => {
  //        errorHandler(error, this.props.dispatch)
  //      })
  //  }

  getFuelEfficiency = async (type) => {
    let result = await axios.get(`/api/vehicles/fuelefficiency?type=${type}`);
    const [key] = Object.keys(result.data);
    const value = result.data[key];
    this.setState({
      form: {
        ...this.state.form,
        fuelEfficiency: value || 0,
      },
    });
    return value;
  };

  getAreas = async () => {
    let result = await axios.get(`api/areas `);
    this.setState({
      areas: result?.data.data || [],
    });
  };

  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  setPagination = () => {
    // if (
    //   this.state.vehiclesData &&
    //   this.state.vehiclesData &&
    //   this.state.vehiclesData.length
    // ) {
    let nAcc = { ...this.state.vehiclesData };
    let lastPage = nAcc.total / this.state.pageSize;
    let IsFloate = this.checkFloteNumber(lastPage);
    delete nAcc.data;
    nAcc.pageSize = this.state.pageSize;
    nAcc.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
    return nAcc;
    // } else {
    //   return {};
    // }
  };
  setPaginationVehiclHistory = () => {
    let nAcc = { ...this.state.vehicleHistoryData };
    let lastPage = nAcc.total / this.state.vehicleHistoryPageSize;
    let IsFloate = this.checkFloteNumber(lastPage);
    delete nAcc.data;
    nAcc.pageSize = this.state.vehicleHistoryPageSize;
    nAcc.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
    return nAcc;
  };
  handleChangePageVehicleHistory = (value) => {
    this.setState({ vehicleHistoryPage: value }, () => {
      this.getVehicleHistoryData(this.state.selectHistoryVehicleId);
    });
  };
  handleChangePerPageVehicleHistory = (rowsPerPage) => {
    this.setState(
      { vehicleHistoryPage: 1, vehicleHistoryPageSize: rowsPerPage },
      () => {
        this.getVehicleHistoryData(this.state.selectHistoryVehicleId);
      },
    );
  };

  handleChangeRowsPerPage1 = (rowsPerPage) => {
    this.setState({ page: 1, rowsPerPage: rowsPerPage });
  };

  handleChangePage1 = (value) => {
    this.setState({
      page: value,
      rowsPerPage: this.state.rowsPerPage,
    });
  };

  handleChangePage = (value) => {
    this.setState({ page: value }, () => {
      this.getVehivlesList();
    });
  };

  removeEnable = (selected) => {
    if (selected[0]) {
      this.setState({
        selectedVehicle: selected[0],
        onDeleteConfirmation: true,
        form: "",
      });
    } else {
      this.setState({
        onDeleteConfirmation: true,
        form: "",
      });
    }
  };
  sendDataEnable = (selected) => {
    if (selected[0]) {
      this.setState({
        selectedVehicle: selected[0],
        onDataSendConfirmation: true,
        form: "",
      });
    } else {
      this.setState({
        onDataSendConfirmation: true,
        form: "",
      });
    }
  };

  onVehicleSendDataCancel = () => {
    this.setState({
      onDataSendConfirmation: false,
    });
  };
  getVehicleHistoryData = (id) => {
    let { vehicleHistoryPage, vehicleHistoryPageSize } = this.state;
    this.setState({ vehicleHistoryLoader: true }, () => {
      instance({
        method: "GET",
        url: `/api/vehicles/get/ownershiplogs?vehicleId=${id}&page=${vehicleHistoryPage}&limit=${vehicleHistoryPageSize}`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.setState({
            vehicleHistoryData: response,
            vehicleHistoryLoader: false,
            vehicleHistoryPageSize: response?.pageSize,
          });
        })
        .catch((error) => {
          console.error("Error fetching vehicle history:", error);
          this.setState({ vehicleHistoryLoader: false });
        });
    });
  };

  handleOpenShowVehicleHistory = (value) => {
    if (value[0]) {
      this.setState(
        {
          showHistoryVehicles: true,
          selectHistoryVehicleId: value[0]?.id,
        },
        () => {
          this.getVehicleHistoryData(this.state.selectHistoryVehicleId);
        },
      );
    }
  };
  handleCancelShowVehicleHistory = () => {
    this.setState({
      showHistoryVehicles: false,
    });
  };
  onCancel = () => {
    this.setState({
      onDeleteConfirmation: false,
    });
  };

  tagSearch = () => {
    this.setState({
      tagSearch: true,
      tagsModelOpen: true,
    });
  };
  resetModelSearch = () => {
    this.setState(
      {
        enableReset: false,
        // tagsModelOpen:false,
        alltags: {},
      },
      () => this.getVehivlesList(),
    );
  };
  closetagSearch = () => {
    this.setState({
      tagSearch: false,
    });
  };

  getVehivlesList = (tags, check) => {
    let { page, pageSize } = this.state;
    source = axios.CancelToken.source();

    const params = new URLSearchParams({
      page,
      limit: pageSize,
      userId: this.props.logInUser.id,
      all: true,
      search: this.state.searchContractText,
    });
    if (this.state.cityIds?.length) {
      this.state.cityIds.forEach((id) => {
        params.append("cityId", id);
      });
    }

    const apiUrl = `api/vehicles/get?${params.toString()}`;
    // Create an array to hold the tag parameters
    const tagParams = [];

    // Check each tag for a value and add it to the tagParams array if it has a value
    if (tags) {
      if (tags.tag_1) tagParams.push(`tag1=${tags.tag_1}`);
      if (tags.tag_2) tagParams.push(`tag2=${tags.tag_2}`);
      if (tags.tag_3) tagParams.push(`tag3=${tags.tag_3}`);
      if (tags.tag_4) tagParams.push(`tag4=${tags.tag_4}`);
      if (tags.tag_5) tagParams.push(`tag5=${tags.tag_5}`);
    }

    // Join the tag parameters with '&' to create the final query string

    // Use a Set to ensure unique values and then convert it back to an array
    const uniqueTagParams = Array.from(new Set(tagParams));
    const tagQueryString = uniqueTagParams.join("&");

    if (tagQueryString) {
      apiUrl += `&${tagQueryString}`;
    }

    const alltags = {
      tag_1: [],
      tag_2: [],
      tag_3: [],
      tag_4: [],
      tag_5: [],
    };

    this.setState(
      {
        loader1: true,
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            let tagsData = response?.data.data?.data.forEach((t) => {
              if (t.attributes.tag_1) alltags.tag_1.push(t.attributes.tag_1);
              if (t.attributes.tag_2) alltags.tag_2.push(t.attributes.tag_2);
              if (t.attributes.tag_3) alltags.tag_3.push(t.attributes.tag_3);
              if (t.attributes.tag_4) alltags.tag_4.push(t.attributes.tag_4);
              if (t.attributes.tag_5) alltags.tag_5.push(t.attributes.tag_5);
            });

            // Check if tags need to be cached
            if (check) {
              cachedTags = { ...alltags };
            }

            this.setState({
              vehiclesData: response?.data.data || [],
              loader1: false,
              tagSearch: false,
              // enableReset:tags?true:false,
              enableReset: !!(tags && Object.keys(tags).length),
              alltags: cachedTags, // Store tags in component's state
            });
          })
          .catch((e) => {
            // Handle error
          });
      },
    );
  };

  getVehiclesFromModel = (vehicles) => {
    this.setState({
      page: 1,
      // pageSize:vehicles.length,
      vehiclesData: {
        page: 1,
        pageSize: 20,
        total: vehicles.length,
        hasNext: true,
        data: vehicles,
      },
      loader1: false,
      tagSearch: false,
    });
  };

  openMulkiya = (vehicle, autoPrint = false) => {
    this.setState({
      mulkiyaVehicle: vehicle || null,
      mulkiyaAutoPrint: !!autoPrint,
    });
  };

  openAssessment = (vehicle) => {
    if (!vehicle?.id || !this.props.navigate) return;
    this.props.navigate(`/vehicle-assessment/${vehicle.id}`, {
      state: { vehicle },
    });
  };

  closeMulkiya = () => {
    this.setState({
      mulkiyaVehicle: null,
      mulkiyaAutoPrint: false,
    });
  };

  downloadMulkiyaPdf = (vehicle) => {
    this.openMulkiya(vehicle, true);
  };

  deleteVehicle = async () => {
    const { selectedVehicle } = this.state;
    let result = await axios.delete(`/api/vehicles/${selectedVehicle.id}`);
    if (result.data.status === "success") {
      // this.getFilteredPAyments(this.state.to,this.state.from,this.state.account,this.state.vehcile,this.state.area)

      toast.success(this.props.translate("Vehicle Deleted"));
      this.setState(
        {
          selectedVehicle: "",
          onDeleteConfirmation: false,
        },
        () => {
          this.getVehivlesList();
        },
      );
      // this.getVehivlesList();
    } else {
      toast.error(this.props.translate(result.data.message));
    }
  };

  onVehicleSendData = () => {
    if (this.state.selectedVehicle) {
      instance({
        url: `/api/vehicles/integrationwithid/${this.state.selectedVehicle?.id}`,
        method: "GET",
      })
        .then((response) => {
          toast.success(this.props.translate(response));
          this.setState(
            {
              selectedVehicle: "",
              onDataSendConfirmation: false,
            },
            () => {
              this.getVehivlesList();
            },
          );
        })
        .catch((error) => {
          errorHandler(error, this.props.dispatch);
          this.setState({
            selectedVehicle: "",
            onDataSendConfirmation: false,
          });
        });
    }
  };

  searchContractText = (e) => {
    source.cancel();
    this.setState({
      searchContractText: e.target.value,
    });
  };

  handleCity = (name, value) => {
    this.setState({
      [name]: value.id,
      selectedCityId: value,
    });
  };

  handleSearchVehicle = () => {
    this.setState(
      {
        page: 1,
      },
      () => {
        this.getVehivlesList();
      },
    );
  };

  isBlankImportValue = (value) => {
    if (value == null) return true;
    if (typeof value === "object") {
      const id = value.id ?? value.value ?? value.cityEn ?? value.name ?? value.label;
      return id == null || id === "" || id === 0;
    }
    return String(value).trim() === "";
  };

  enforceImportRequiredFields = (items = [], isStatusUpload = false) => {
    if (isStatusUpload) return items;

    return items.map((item) => {
      const attrs = { ...(item.attributes || {}) };
      const invalidList = Array.isArray(attrs.invalidList)
        ? [...attrs.invalidList]
        : [];
      const reasons = Array.isArray(attrs.reason)
        ? [...attrs.reason]
        : attrs.reason
          ? [String(attrs.reason)]
          : [];

      const makeVal = item.make ?? item.makeName ?? attrs.make;
      const modelVal =
        item.model ?? item.modelName ?? attrs.model ?? item.modelId;
      const cityVal =
        item.cityId ??
        item.city ??
        item.cityName ??
        attrs.city ??
        attrs.cityName ??
        attrs.cityId;

      const missingMsgs = [];
      if (this.isBlankImportValue(makeVal)) {
        if (!invalidList.includes("make")) invalidList.push("make");
        missingMsgs.push("Make is required");
      }
      if (this.isBlankImportValue(modelVal)) {
        if (!invalidList.includes("model")) invalidList.push("model");
        missingMsgs.push("Model is required");
      }
      if (this.isBlankImportValue(cityVal)) {
        if (!invalidList.includes("city")) invalidList.push("city");
        missingMsgs.push("City is required");
      }

      if (!missingMsgs.length) {
        return item;
      }

      return {
        ...item,
        attributes: {
          ...attrs,
          invalid: true,
          invalidList,
          reason: [...reasons, ...missingMsgs],
        },
      };
    });
  };

  openImportTable = (items, user) => {
    let validVehicles = [];
    let invalidVehicles = [];
    let newArray1;
    let userId = user ? user.id : this.props.logInUser.id;
    let status = false;
    const isStatusUpload = user === "vehicleStatus";
    const normalizedItems = this.enforceImportRequiredFields(
      items || [],
      isStatusUpload,
    );

    normalizedItems.forEach((item) => {
      if (
        item.attributes.invalidList &&
        item.attributes.invalidList.length > 0
      ) {
        // If invalidList is not empty, mark the vehicle as invalid
        invalidVehicles.push(item);
      } else {
        // If invalidList is empty, mark the vehicle as valid
        validVehicles.push(item);
      }
    });
    const duplicateVin = normalizedItems.filter((data) =>
      data?.attributes?.reason?.includes("Duplicate Vin"),
    );

    const duplicateLicensePlate = normalizedItems.filter((data) =>
      data?.attributes?.reason?.includes("Duplicate vehicleLicensePlate"),
    );

    if (isStatusUpload) {
      newArray1 = normalizedItems.filter((item) => !item.attributes.invalid);
      this.setState({ isVehicleStatus: true });
    } else {
      newArray1 = validVehicles.map((item) => {
        const {
          attributes: { invalidList, ...restAttributes },
          modelName,
          makeName,
          ...restItem
        } = item;
        // Create a new object without the invalidList, modelName, makeName property
        const newObj = {
          ...restItem,
          attributes: restAttributes,
        };
        return newObj;
      });
      this.setState({ isVehicleStatus: false });
    }

    //  if(status === false) {
    this.setState({ isImportBtnDisabled: false });

    // Store all necessary information in the state
    this.setState({
      showImportedVehicleSampleError: true,

      allVehiclesValid: status,
      showImportedInvoiceError: true,
      importedInvoiceData: normalizedItems,
      uploadedVehicles: normalizedItems,
      selectedUserId: userId,
      validVehicles: validVehicles,
      inValidVehicles: invalidVehicles,
      selectedVehicleList: newArray1,
      duplicateVin: duplicateVin,
      duplicateLicensePlate: duplicateLicensePlate,
    });
  };

  SubmitImport = (e) => {
    const objFor =
      this.state.selectedVehicleList && this.state.selectedVehicleList;
    const url = this.state.isVehicleStatus
      ? `/api/vehicles/vehiclewrappersstatus`
      : `/api/vehicles/vehiclewrappers?userId=${this.state.selectedUserId}`;
    instance({
      url: url,
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: objFor,
    })
      .then((res) => {
        toast.success(
          this.props.translate(
            "Total " +
              res.total +
              "   " +
              "  Added " +
              "   " +
              res.added +
              "    " +
              " Skipped " +
              "   " +
              res.skipped,
          ),
        );
        // this.onCloseColorModel();
        this.setState(
          {
            showImportedInvoiceError: false,
            vehicleStatusButton: "all",
          },
          () => {
            this.onCloseImportedModal();
            this.getVehivlesList();
          },
        );
      })
      .catch((err) => {
        const splitString = err.message.split(": ");
        let result;
        if (splitString.length >= 2) {
          result = splitString[1]; // Take the second part after splitting
        }

        toast.error(this.props.translate(result));
      });
  };

  handleSubmit = async () => {
    // event.preventDefault();
    let { form } = this.state;

    try {
      const url = await this.resolveVehicleUploadUrl(form, 0);
      const obj = vehicleDataFormat(
        { ...form, url },
        "",
        this.state.selectedUser,
        this.props.logInUser,
      );

      const result = await axios.post(`/api/vehicles`, obj);

      if (result.data.status === "success") {
        // this.props.dispatch(addvehicle(result.data.data));
        this.setState({
          addOption: false,
          editOption: false,
          isVisableUserBtn: false,
          selectedUser: "",
          newVehicleId: result?.data?.data?.id,
          submitForm: true,
          form: { ...formDefault },
        });

        toast.success(this.props.translate("Vehicle Added"));
        this.getVehivlesList();
      } else {
        toast.error(
          this.props.translate(result?.data?.message || "Something went wrong"),
        );
      }
    } catch (error) {
      toast.error(
        this.props.translate(error?.message || "Something went wrong"),
      );
    }
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ page: 1, pageSize: rowsPerPage }, () => {
      this.getVehivlesList();
    });
  };

  getVehicleData = async () => {
    try {
      const { vin } = this.state.form;
      const result = await axios.get(`/api/trigger/vindecoder2?vin=${vin}`);
      const vehicleData = parseVinDecoderResponse(result?.data);

      if (!vehicleData) {
        toast.error(
          this.props.translate("noRecordFound") || "No vehicle data found",
        );
        return;
      }

      this.setState({
        showVinConfirmDialog: true,
        pendingVinVehicleData: vehicleData,
      });
    } catch (error) {
      console.error("VIN decoder error:", error);
      toast.error(
        this.props.translate("somethingWentWrong") ||
          "Something went wrong while fetching vehicle data",
      );
    }
  };

  applyVinDecoderData = (vehicleData) => {
    const {
      bodyType,
      fuelEfficiency,
      modelId,
      modelName,
      maker,
      model,
      trim,
      modelYear,
      color,
      exteriorColor,
      interiorColor,
      fuelType,
      transmission,
      engineSize,
      origin,
      manufacturedIn,
      driveType,
      doors,
      seatingDetails,
      horsepower,
      cylinders,
      manufacturerName,
      makerAR,
      modelAR,
      mpgCity,
      mpgHighway,
      settings,
      ...remainingVehicleData
    } = vehicleData;

    const cleanedVehicleData = Object.fromEntries(
      Object.entries(remainingVehicleData).filter(
        ([_, value]) => value != null && value !== "",
      ),
    );

    const flattenedSettings =
      settings && typeof settings === "object" && !Array.isArray(settings)
        ? Object.fromEntries(
            Object.entries(settings).filter(
              ([_, value]) => value != null && value !== "",
            ),
          )
        : {};

    const resolvedCategory = resolveVinCategory(
      bodyType,
      this.state.categories,
    );
    const resolvedFuelType = normalizeVinFuelType(fuelType);
    const resolvedTransmission = normalizeVinTransmission(transmission);
    const makeOption = maker
      ? {
          id: maker,
          key: maker,
          label: maker,
          value: maker,
        }
      : null;
    const autoLabel = [maker, model, modelYear].filter(Boolean).join(" ");

    this.setState(
      (prevState) => {
        const existingMakes = Array.isArray(prevState.allMakes)
          ? prevState.allMakes
          : [];
        const existingCategories = Array.isArray(prevState.categories)
          ? prevState.categories
          : [];
        const makeAlreadyListed =
          makeOption &&
          existingMakes.some(
            (item) =>
              String(item.label || item.key || item.value).toLowerCase() ===
              makeOption.label.toLowerCase(),
          );
        const categoryAlreadyListed =
          resolvedCategory &&
          existingCategories.some(
            (item) =>
              String(item).toLowerCase() === resolvedCategory.toLowerCase(),
          );

        return {
          allMakes:
            makeOption && !makeAlreadyListed
              ? [makeOption, ...existingMakes]
              : existingMakes,
          categories:
            resolvedCategory && !categoryAlreadyListed
              ? [...existingCategories, resolvedCategory]
              : existingCategories,
          form: {
            ...prevState.form,
            label: prevState.form.label?.trim()
              ? prevState.form.label
              : autoLabel || prevState.form.label,
            category: resolvedCategory || prevState.form.category,
            fuelEfficiency: fuelEfficiency || prevState.form.fuelEfficiency,
            modelId: modelId
              ? {
                  id: modelId,
                  label: modelName || model,
                }
              : prevState.form.modelId,
            make: makeOption || prevState.form.make,
            attributes: {
              ...prevState.form.attributes,
              ...cleanedVehicleData,
              ...flattenedSettings,
              make: maker || prevState.form.attributes?.make,
              model: model || prevState.form.attributes?.model,
              variant: trim || prevState.form.attributes?.variant,
              year: modelYear || prevState.form.attributes?.year,
              color: color || exteriorColor || prevState.form.attributes?.color,
              interiorColor:
                interiorColor || prevState.form.attributes?.interiorColor,
              fuel_type:
                resolvedFuelType || prevState.form.attributes?.fuel_type,
              trasmissionType:
                resolvedTransmission ||
                prevState.form.attributes?.trasmissionType,
              capacity: engineSize || prevState.form.attributes?.capacity,
              country:
                manufacturedIn || origin || prevState.form.attributes?.country,
              driveType: driveType || prevState.form.attributes?.driveType,
              doors: doors || prevState.form.attributes?.doors,
              seatingDetails:
                seatingDetails || prevState.form.attributes?.seatingDetails,
              horsepower: horsepower || prevState.form.attributes?.horsepower,
              cylinders: cylinders || prevState.form.attributes?.cylinders,
              manufacturerName:
                manufacturerName || prevState.form.attributes?.manufacturerName,
              makerAR: makerAR || prevState.form.attributes?.makerAR,
              modelAR: modelAR || prevState.form.attributes?.modelAR,
              mpgCity: mpgCity || prevState.form.attributes?.mpgCity,
              mpgHighway: mpgHighway || prevState.form.attributes?.mpgHighway,
            },
          },
        };
      },
      async () => {
        const make = this.state.form.attributes?.make;
        const category = this.state.form.category;

        if (category) {
          this.getFuelEfficiency(category);
        }

        if (make) {
          const models = await this.fetchVehicleMake(make);
          const findModel = models.find(
            (item) =>
              (item?.modelName || "").toLowerCase() ===
              (model || "").toLowerCase(),
          );
          this.setState((prevState) => ({
            form: {
              ...prevState.form,
              modelId: findModel
                ? {
                    id: findModel.id,
                    label: findModel.modelName,
                    value: findModel.id,
                  }
                : prevState.form.modelId,
            },
            selectedMakeTypes: models,
          }));
        }

        this.checkRequiredFields();
      },
    );
  };

  handleVinConfirmYes = () => {
    const { pendingVinVehicleData } = this.state;
    if (pendingVinVehicleData) {
      this.applyVinDecoderData(pendingVinVehicleData);
    }
    this.setState({
      showVinConfirmDialog: false,
      pendingVinVehicleData: null,
    });
  };

  handleVinConfirmNo = () => {
    this.setState({
      showVinConfirmDialog: false,
      pendingVinVehicleData: null,
    });
  };

  formatVinDetailKey = (key) => {
    return key
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  getVinDetailLabel = (key) => {
    const translated = this.props.translate(key);
    return translated && translated !== key
      ? translated
      : this.formatVinDetailKey(key);
  };

  formatVinDetailValue = (value) => {
    if (value === null || value === undefined) return "";
    if (Array.isArray(value)) return value.join(", ");
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
  };

  getVinDetailEntries = (data) => {
    if (!data) return [];

    const entries = [];

    Object.entries(data).forEach(([key, value]) => {
      if (value === null || value === undefined || value === "") return;

      if (
        key === "settings" &&
        value &&
        typeof value === "object" &&
        !Array.isArray(value)
      ) {
        Object.entries(value).forEach(([settingKey, settingValue]) => {
          if (
            settingValue === null ||
            settingValue === undefined ||
            settingValue === ""
          ) {
            return;
          }
          entries.push([settingKey, settingValue]);
        });
        return;
      }

      if (typeof value === "object") return;

      entries.push([key, value]);
    });

    return entries;
  };

  getVinConfirmPreview = () => {
    const data = this.state.pendingVinVehicleData;
    if (!data) return null;
    const parts = [data.maker, data.model, data.modelYear].filter(Boolean);
    return parts.length ? parts.join(" · ") : null;
  };

  getVinConfirmDetails = () => {
    const data = this.state.pendingVinVehicleData;
    if (!data) return null;

    const entries = this.getVinDetailEntries(data);

    if (!entries.length) return null;

    return (
      <div style={{ marginTop: 12, maxHeight: 320, overflowY: "auto" }}>
        {entries.map(([key, value]) => (
          <div
            key={key}
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "6px 0",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <span style={{ fontWeight: 600, color: "#333" }}>
              {this.getVinDetailLabel(key)}
            </span>
            <span style={{ color: "#555", marginLeft: 12, textAlign: "right" }}>
              {this.formatVinDetailValue(value)}
            </span>
          </div>
        ))}
      </div>
    );
  };

  handleChangeTabs = (value) => {
    this.setState(
      {
        vehicleStatusButton: value,
        vehicleUploadPage: 0,
      },
      () => {
        let uploadedVehicles = [];
        switch (value) {
          case "valid":
            uploadedVehicles = this.state.validVehicles;
            break;
          case "inValid":
            uploadedVehicles = this.state.inValidVehicles;
            break;
          case "all":
            uploadedVehicles = this.state.importedInvoiceData;
            break;
          case "duplicatePlate":
            uploadedVehicles = this.state.duplicateLicensePlate;
            break;
          case "duplicateVin":
            uploadedVehicles = this.state.duplicateVin;
            break;
          default:
            uploadedVehicles = [];
            break;
        }

        const isUpdatePageSize =
          uploadedVehicles?.length <= 50
            ? 10
            : this.state.vehicleUploadPageSize;

        this.setState({
          uploadedVehicles,
          vehicleUploadPageSize: isUpdatePageSize,
        });
      },
    );
  };
  handleChangeRowsPerPageUpload = (rowsPerPage) => {
    this.setState({ vehicleUploadPage: 0, vehicleUploadPageSize: rowsPerPage });
  };

  handleChangePageUpload = (value) => {
    this.setState({
      vehicleUploadPage: value,
      vehicleUploadPageSize: this.state.vehicleUploadPageSize,
    });
  };

  handleOpenArchivedVehicles = () => {
    this.setState({
      archivedVehiclesTable: true,
    });
  };
  handleCloseArchivedVehicle = () => {
    this.setState(
      {
        archivedVehiclesTable: false,
      },
      () => {
        this.getVehivlesList({}, true);
      },
    );
  };

  fetchVehicleDns = async (vehicleId) => {
    if (this.controllerRef.current) {
      this.controllerRef.current.abort();
    }

    this.controllerRef.current = new AbortController();

    this.setState({ isLoadingVehicleDns: true });

    try {
      const response = await instance.get(`/api/deliverynotes/get`, {
        params: {
          page: this.state.vehicleDns.page,
          limit: this.state.vehicleDns.pageSize,
          plateNumber: vehicleId,
        },
        signal: this.controllerRef.current.signal,
      });

      this.setState((prevState) => ({
        vehicleDns: {
          ...prevState.vehicleDns,
          ...response,
        },
      }));
    } catch (error) {
      if (error.name === "CanceledError") {
        console.log("Request canceled");
      } else {
        console.error("Error fetching vehicle delivery notes:", error);
      }
    } finally {
      this.setState({ isLoadingVehicleDns: false });
    }
  };

  handleVehicleRowClick = (rows) => {
    const vehicleId = rows?.[0]?.vehicleLicensePlate;
    if (vehicleId) {
      this.setState(
        {
          selectedVehicleId: vehicleId,
          isVehicleDnsModalOpen: true,
        },
        () => {
          this.fetchVehicleDns(vehicleId);
        },
      );
    }
  };

  handleCloseVehicleDnsModal = () => {
    if (this.controllerRef.current) {
      this.controllerRef.current.abort();
    }

    this.setState({
      isVehicleDnsModalOpen: false,
      selectedVehicleId: null,
      vehicleDns: {
        data: [],
        page: 1,
        pageSize: 10,
        total: 0,
      },
    });
  };

  handleVehicleDnsPageChange = (newPage) => {
    this.setState(
      (prevState) => ({
        vehicleDns: {
          ...prevState.vehicleDns,
          page: newPage,
        },
      }),
      () => {
        const { selectedVehicleId, isVehicleDnsModalOpen } = this.state;
        if (selectedVehicleId && isVehicleDnsModalOpen) {
          this.fetchVehicleDns(selectedVehicleId);
        }
      },
    );
  };

  handleVehicleDnsPageSizeChange = (newPageSize) => {
    this.setState(
      (prevState) => ({
        vehicleDns: {
          ...prevState.vehicleDns,
          pageSize: newPageSize,
          page: 1,
        },
      }),
      () => {
        const { selectedVehicleId, isVehicleDnsModalOpen } = this.state;
        if (selectedVehicleId && isVehicleDnsModalOpen) {
          this.fetchVehicleDns(selectedVehicleId);
        }
      },
    );
  };

  getPaginationForVehicleDns = () => {
    const { page, pageSize, total } = this.state.vehicleDns;
    const lastPage = total / pageSize;
    return {
      page,
      pageSize,
      total,
      lastPage: this.checkFloteNumber(lastPage)
        ? Math.floor(lastPage) + 1
        : lastPage,
    };
  };
  handleCityChange = (ids, type) => {
    const idArray = Array.isArray(ids) ? ids : [ids];

    const query = idArray.length
      ? idArray.map((id) => `&cityId=${id}`).join("")
      : "";

    this.setState({
      cityIds: ids,
      selectedVehicleCityId: query,
    });
  };
  handleOpenCitySelector = (event) => {
    this.setState({ cityAnchor: event.currentTarget });
  };

  handleCloseCitySelector = () => {
    this.setState({ cityAnchor: null });
  };
  handleFinish = () => {
    this.setState(
      {
        submitForm: false,
        newVehicleId: "",
      },
      () => {
        toast.success("Changes saved");
      },
    );
  };

  render() {
    const { selectedCityId } = this.state;
    const csvData = this.state.uploadedVehicles?.map((vehicle) => ({
      label: vehicle.label || "",
      category: vehicle.category || "",
      vehicleLicensePlate: vehicle.vehicleLicensePlate || "",
      make: vehicle.make || "",
      model: vehicle.model || "",
      capacity: vehicle.capacity || "",
      vin: vehicle.vin || "",
      garage: vehicle.garage || "",
      reason: Array.isArray(vehicle?.attributes?.reason)
        ? vehicle.attributes.reason.join(", ")
        : vehicle.attributes?.reason || "",
    }));

    const { isVehicleDnsModalOpen, vehicleDns, isLoadingVehicleDns } =
      this.state;
    const { translate, themecolors } = this.props;

    if (this.state.openingNavEdit && !this.state.editOption) {
      return (
        <div style={{ textAlign: "center", padding: 40 }}>
          <Loader defaultStyle />
        </div>
      );
    }

    return (
      <div>
        <Style>{`
            .custom-tab-button {
              min-height: 29px;
              border-radius: 6px 6px 0 0;
              margin: 0 2px;
              background: ${this.props.themecolors["600"]};
              color: ${this.props.themecolors["themeInverse"]};
            }
            .custom-tabs {
              min-height: 30px;
              margin: 10px 6px 0;
            }

            .custom-tab-button-selected {
              background: ${this.props.themecolors["500"]};
              color: ${this.props.themecolors["themeInverse"]};
            }`}</Style>

        {this.state.submitForm ? (
          <UserAccessVehicle
            {...this.props}
            {...this.state}
            handleFinish={this.handleFinish}
            replaceHtmlEntities={this.replaceHtmlEntities}
          />
        ) : this.state.addOption ? (
          <Fragment>
            <AddVehicleModal
              {...this.state}
              {...this.props}
              fetchCategories={this.fetchCategories}
              searchMakesList={this.searchMakesList}
              loadMoreMakes={this.loadMoreMakes}
              makesLoading={this.state.makesLoading}
              getVehicleData={this.getVehicleData}
              title={this.props.translate("addVehicle")}
              formSubmit={this.handleSubmit}
              handleChangeLicenseExpDate={this.handleChangeLicenseExpDate}
              handleChangeForAttributesValues={
                this.handleChangeForAttributesValues
              }
              handleChange1={this.handleChange1}
              onChangedDevice={this.onChangedDevice}
              form={this.state.form}
              handleChange={this.handleChange}
              handleChangeUser={this.handleChangeUser}
              handleVehicleFileChange={this.handleVehicleFileChange}
              removeVehicleFile={this.removeVehicleFile}
              removeVehicleSavedFile={this.removeVehicleSavedFile}
              downloadVehicleFile={this.downloadVehicleFile}
              decodeFileUrl={decodeFileUrl}
              vehicleFilesData={this.state.vehicleFilesData}
              modalControle={this.modalControle}
              buttonText={this.props.translate("sharedCreate")}
              resetVehicleValidation={this.resetVehicleValidation}
              creatingUnit
            />
          </Fragment>
        ) : this.state.editOption ? (
          <Fragment>
            <ViewUserDetail
              {...this.state}
              {...this.props}
              fetchCategories={this.fetchCategories}
              searchMakesList={this.searchMakesList}
              loadMoreMakes={this.loadMoreMakes}
              makesLoading={this.state.makesLoading}
              getVehicleData={this.getVehicleData}
              selectedUser={this.state.selectedUser}
              title={this.props.translate("updateVehicle")}
              formSubmit={this.updateVehicle}
              // form={this.state.selectedVehicle}
              form={this.state.form}
              handleChange={this.handleChange}
              onChangedDevice={this.onChangedDevice}
              handleChangeUser={this.handleChangeUser}
              handleChangeLicenseExpDate={this.handleChangeLicenseExpDate}
              handleChangeForAttributesValues={
                this.handleChangeForAttributesValues
              }
              handleVehicleFileChange={this.handleVehicleFileChange}
              removeVehicleFile={this.removeVehicleFile}
              removeVehicleSavedFile={this.removeVehicleSavedFile}
              downloadVehicleFile={this.downloadVehicleFile}
              decodeFileUrl={decodeFileUrl}
              vehicleFilesData={this.state.vehicleFilesData}
              getVehivlesList={this.getVehivlesList}
              handleChange1={this.handleChange1}
              modalControle={this.modalControle}
              buttonText={this.props.translate("Update")}
              resetVehicleValidation={this.resetVehicleValidation}
              enableUpdateButton={this.enableUpdateButton}
              creatingUnit
            />
            {/* <AddVehicleModal
              {...this.state}
              {...this.props}
              title={this.props.translate("updateVehicle")}
              formSubmit={this.updateVehicle}
              // form={this.state.selectedVehicle}
              form={this.state.form}
              handleChange={this.handleChange}
              handleChangeUser={this.handleChangeUser}
              handleChangeLicenseExpDate={this.handleChangeLicenseExpDate}
              handleChangeForAttributesValues={
                this.handleChangeForAttributesValues
              }
              handleChange1={this.handleChange1}
              modalControle={this.modalControle}
              buttonText={this.props.translate("Update")}
              creatingUnit
            /> */}
          </Fragment>
        ) : (
          <>
            {!this.state.archivedVehiclesTable && (
              <Grid
                container
                className="breadcrumb-row"
                style={{ paddingLeft: 10, paddingRight: 10 }}
              >
                <Grid item xs={12} sm={2}>
                  <h3 style={{ margin: 0 }}>
                    {this.props.translate("vehicles")}
                  </h3>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={10}
                  style={{ justifyContent: "flex-end" }}
                >
                  <div style={{ width: "15%", marginRight: 15 }}>
                    <Button
                      // disabled={!(checkPrivileges("vehicleCreate") ? true : false)}
                      aria-label="modelSearch"
                      size="small"
                      color="inherit"
                      onClick={this.handleOpenArchivedVehicles}
                      id="modelSearch"
                    >
                      {this.props.translate("archivedVehicles")}
                    </Button>
                  </div>
                  <div style={{ width: "10%", marginRight: 10 }}>
                    <Button
                      // disabled={!(checkPrivileges("vehicleCreate") ? true : false)}
                      aria-label="modelSearch"
                      size="small"
                      color="inherit"
                      onClick={this.tagSearch}
                      id="modelSearch"
                    >
                      {this.props.translate("modelSearch")}
                    </Button>
                  </div>
                  <div style={{ width: "10%", marginRight: 10 }}>
                    <Button
                      disabled={!this.state.enableReset}
                      aria-label="reset"
                      size="small"
                      color="inherit"
                      onClick={this.resetModelSearch}
                      id="reset"
                    >
                      {this.props.translate("reset")}
                    </Button>
                  </div>
                  <div style={{ width: "25%", marginRight: 10 }}>
                    <TextField
                      fullWidth
                      label={this.props.translate("search")}
                      value={this.state.searchContractText}
                      onChange={(e) => this.searchContractText(e)}
                    />
                  </div>
                  {/* <div style={{ width: "25%", marginRight: 10 }}>
                    <SingleSelect
                      array={this.props.cities || []}
                      async
                      selectName="cityId"
                      isClearable
                      label={this.props.translate("city")}
                      value={
                        selectedCityId
                          ? {
                            id: selectedCityId?.id,
                            value: selectedCityId?.cityEn || selectedCityId?.name,
                            label: selectedCityId?.cityEn || selectedCityId?.name,
                          }
                          : ""
                      }
                      handleChange={this.handleCity}
                      canAssign={true}
                      hidebg
                      menuPlacement="auto"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        backgroundColor: "transparent !important"
                      }}
                    />
                  </div> */}
                  <div style={{ width: "25%", marginRight: 10 }}>
                    <Button
                      // variant="outlined"
                      size="small"
                      startIcon={<LocationCityIcon />}
                      onClick={this.handleOpenCitySelector}
                    >
                      Select City
                      {this.state.cityIds?.length > 0 &&
                        ` (${this.state.cityIds?.length})`}
                    </Button>

                    <Popover
                      open={Boolean(this.state.cityAnchor)}
                      anchorEl={this.state.cityAnchor}
                      onClose={this.handleCloseCitySelector}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                    >
                      <div style={{ padding: 10, width: 280 }}>
                        <CitySelector
                          userId={this.props.logInUser?.id}
                          value={this.state.cityIds}
                          onChange={this.handleCityChange}
                        />
                      </div>
                    </Popover>
                  </div>
                  <div style={{ width: "10%", marginRight: 5 }}>
                    <Button
                      aria-label="search"
                      size="small"
                      color="inherit"
                      onClick={this.handleSearchVehicle}
                      id="search"
                    >
                      {this.props.translate("search")}
                    </Button>
                  </div>

                  <Button
                    disabled={
                      !(checkPrivileges("vehicleCreate") ? true : false)
                    }
                    aria-label="Create"
                    size="small"
                    color="inherit"
                    onClick={this.openModale}
                    id="createButton"
                  >
                    {this.props.translate("create")}
                  </Button>
                  <div style={{ width: "10%", marginRight: 35 }}>
                    <ExportImportMenu
                      fileName="vehicles"
                      checkPrivilege="serviceCreate"
                      isServices
                      // data={this.props?.invoicesData?.data || []}
                      themecolors={this.props.themecolors}
                      categoryName={this.props?.selectedServiceTypeId || ""}
                      openImportTable={this.openImportTable}
                      translate={this.props.translate}
                      // downloadMakeModelList={this.downloadMakeModelList}
                    />
                  </div>
                  {/* <Button
                    aria-label="Back"
                    size="small"
                    color="inherit"
                    onClick={this.props.goBack}
                    id="back"
                    style={{ margin: 10 }}
                  >
                    {this.props.translate("back")}
                  </Button> */}
                </Grid>
              </Grid>
            )}
            {!this.state.archivedVehiclesTable ? (
              this.state.loader1 ? (
                <Loader />
              ) : (
                <Table
                  rows={
                    Array.isArray(this.state.vehiclesData)
                      ? this.state.vehiclesData
                      : this.state.vehiclesData?.data || []
                  }
                  // rows={this.state.vehiclesData?.data || []}
                  pagination={this.setPagination()}
                  handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                  translate={this.props.translate}
                  // rowsPerPage={15}
                  SearchItem={this.SearchItem}
                  handleChangePage={this.handleChangePage}
                  isEditable
                  onClick={this.onEdit}
                  onVehicleSendData={this.sendDataEnable}
                  hasAccessOfVehicleSendData={checkPrivileges(
                    "vehicleIntegrateSingle",
                  )}
                  canUpdate
                  isCursoPointer
                  isShowVehiclHistory
                  isVehicleTable
                  isShowVehicleActionsMenu
                  archiveTable
                  handleArchivedVehicleHistory={this.handleVehicleRowClick}
                  handleOpenShowVehicleHistory={
                    this.handleOpenShowVehicleHistory
                  }
                  // canDelete
                  // onEdit={this.onEdit}
                  onDelete={this.removeEnable}
                  onViewMulkiya={this.openMulkiya}
                  onDownloadMulkiyaPdf={this.downloadMulkiyaPdf}
                  onViewAssessment={this.openAssessment}
                  hasAccessOfDelete={checkPrivileges("vehicleDelete")}
                  hasAccessOfUpdate={checkPrivileges("vehicleUpdate")}
                  themecolors={this.props.themecolors}
                  // contractNumber={this.props?.selectedAccount?.contractNumber || ''}
                  // downloadInvoicePdf={this.downloadInvoicePdf}
                  // leasing={this.props.leasing}
                  rowDefinition={[
                    {
                      id: "label",
                      // numeric: false,
                      // disablePadding: false,
                      label: this.props.translate("label"),
                    },
                    {
                      id: "category",
                      // numeric: false,
                      // disablePadding: false,
                      label: this.props.translate("vehicleType"),
                    },
                    {
                      id: "vehicleLicensePlate",
                      numeric: false,
                      disablePadding: false,
                      label: this.props.translate("vehicleLicensePlate"),
                    },
                    {
                      id: "attributes.parentName",
                      numeric: false,
                      disablePadding: false,
                      label: this.props.translate("account"),
                    },
                    {
                      id: "attributes.contractNumber",
                      numeric: false,
                      disablePadding: false,
                      label: this.props.translate("contractNumber"),
                    },
                    {
                      id: "makeName",
                      numeric: false,
                      disablePadding: false,
                      label: this.props.translate("make"),
                    },
                    {
                      id: "purchaseDate",
                      numeric: false,
                      disablePadding: false,
                      label: this.props.translate("purchaseDate"),
                    },
                    {
                      id: "year",
                      numeric: false,
                      disablePadding: false,
                      label: this.props.translate("year"),
                    },
                    {
                      id: "vin",
                      numeric: false,
                      disablePadding: false,
                      label: this.props.translate("vin"),
                    },
                    // {
                    //   id: "monthlyRate",
                    //   numeric: false,
                    //   disablePadding: false,
                    //   label: this.props.translate("monthlyRate"),
                    // },
                    // {
                    //   id: "saleTotalAmount",
                    //   numeric: false,
                    //   disablePadding: false,
                    //   label: this.props.translate("Total Amount"),
                    // },
                    {
                      id: "deliveryDate",
                      numeric: false,
                      disablePadding: false,
                      label: this.props.translate("deliveryDate"),
                      // hide: false,
                    },
                    {
                      id: "attributes.depreciationCost",
                      numeric: false,
                      disablePadding: false,
                      label: this.props.translate("depreciationCost"),
                      // hide: false,
                    },
                    {
                      id: "attributes.autoRegister",
                      numeric: false,
                      disablePadding: false,
                      label: this.props.translate("creationMode"),
                    },
                    {
                      id: "created",
                      numeric: false,
                      disablePadding: false,
                      label: this.props.translate("created"),
                      // hide: false,
                    },
                    // {
                    //   id: 'valid',
                    //   numeric: false,
                    //   disablePadding: false,
                    //   label: this.props.translate('valid')
                    // },
                  ]}
                />
              )
            ) : (
              <ArchivedVehiclesTable
                translate={this.props.translate}
                themecolors={this.props.themecolors}
                logInUser={this.props.logInUser}
                handleCloseArchivedVehicle={this.handleCloseArchivedVehicle}
              />
            )}
          </>
        )}

        {this.state.tagSearch ? (
          <VehicleFilerModal
            {...this.props}
            alltags={this.state.alltags}
            getVehiclesFromModel={this.getVehiclesFromModel}
            getVehiclesList={this.getVehivlesList}
            vehiclesData={this.state.vehiclesData?.data || []}
            tags={this.props.tags}
            onCancel={this.closetagSearch}
            onOk={this.closetagSearch}
            onClose={this.closetagSearch}
            showSubmitbtn
            userTags={this.props.logInUser.attributes}
            title={this.props.translate("vehicleFilter")}
            // children={ }
          />
        ) : null}

        {this.state.showImportedInvoiceError && (
          <CustomDialog
            title="Imported Vehicle"
            visable={true}
            onClose={this.onCloseImportedModal}
            bodyPadding={10}
            hideDragIcon
            fullWidth
            isVisableBtn
            noFullScreen
            showSubmitbtn
            // isImportBtnDisabled={this.state.isImportBtnDisabled}
            isImportBtnDisabled={false}
            maxWidth={"lg"}
            handleSubmit={this.SubmitImport}
          >
            {/* {this.state?.allVehiclesValid ?  */}

            {this.state.isVehicleStatus ? (
              <EnhancedTable
                rows={this.state.uploadedVehicles || []}
                isCursoPointer
                rowDefinition={[
                  {
                    id: "vehicleLicensePlate",
                    label: this.props.translate("vehicleLicensePlate"),
                  },
                  {
                    id: "vehicleStatus",
                    label: this.props.translate("status"),
                  },
                ]}
              />
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Button
                      variant="contained"
                      disabled={false}
                      onClick={() => this.handleChangeTabs("all")}
                      style={{
                        // width: "50%",
                        // borderTopRightRadius: " 15px",
                        // borderTopLeftRadius: "15px",
                        marginLeft: "5px",
                        backgroundColor:
                          this.state.vehicleStatusButton === "all"
                            ? themecolors.themeLightColor
                            : "#ffff",
                        color:
                          this.state.vehicleStatusButton === "all"
                            ? "#ffff"
                            : themecolors.themeLightColor,
                      }}
                    >
                      {" "}
                      {this.props.translate("all")}
                    </Button>
                    <Button
                      variant="contained"
                      disabled={false}
                      onClick={() => this.handleChangeTabs("valid")}
                      style={{
                        // width: "50%",
                        // borderTopRightRadius: " 15px",
                        // borderTopLeftRadius: "15px",
                        marginLeft: "5px",
                        backgroundColor:
                          this.state.vehicleStatusButton === "valid"
                            ? themecolors.themeLightColor
                            : "#ffff",
                        color:
                          this.state.vehicleStatusButton === "valid"
                            ? "#ffff"
                            : themecolors.themeLightColor,
                      }}
                    >
                      {" "}
                      {this.props.translate("valid")}
                    </Button>
                    <Button
                      variant="contained"
                      disabled={false}
                      onClick={() => this.handleChangeTabs("inValid")}
                      style={{
                        // width: "50%",
                        // borderTopRightRadius: " 15px",
                        // borderTopLeftRadius: "15px",
                        marginLeft: "5px",
                        backgroundColor:
                          this.state.vehicleStatusButton === "inValid"
                            ? themecolors.themeLightColor
                            : "#ffff",
                        color:
                          this.state.vehicleStatusButton === "inValid"
                            ? "#ffff"
                            : themecolors.themeLightColor,
                      }}
                    >
                      {" "}
                      {this.props.translate("inValid")}
                    </Button>
                    <Button
                      variant="contained"
                      disabled={false}
                      onClick={() => this.handleChangeTabs("duplicateVin")}
                      style={{
                        // width: "50%",
                        // borderTopRightRadius: " 15px",
                        // borderTopLeftRadius: "15px",
                        marginLeft: "5px",
                        backgroundColor:
                          this.state.vehicleStatusButton === "duplicateVin"
                            ? themecolors.themeLightColor
                            : "#ffff",
                        color:
                          this.state.vehicleStatusButton === "duplicateVin"
                            ? "#ffff"
                            : themecolors.themeLightColor,
                      }}
                    >
                      {" "}
                      {this.props.translate("duplicateVin")}
                    </Button>
                    <Button
                      variant="contained"
                      disabled={false}
                      onClick={() => this.handleChangeTabs("duplicatePlate")}
                      style={{
                        // width: "50%",
                        // borderTopRightRadius: " 15px",
                        // borderTopLeftRadius: "15px",
                        marginLeft: "5px",
                        backgroundColor:
                          this.state.vehicleStatusButton === "duplicatePlate"
                            ? themecolors.themeLightColor
                            : "#ffff",
                        color:
                          this.state.vehicleStatusButton === "duplicatePlate"
                            ? "#ffff"
                            : themecolors.themeLightColor,
                      }}
                    >
                      {" "}
                      {this.props.translate("duplicatePlate")}
                    </Button>
                  </div>

                  <div>
                    <CSVLink
                      data={csvData}
                      headers={vehicleHeaders}
                      filename={`${(this.state.vehicleStatusButton || "All").replace(/\s+/g, "_")}_vehicles.csv`}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: "10px" }}
                      >
                        {this.props.translate("Download CSV")}
                      </Button>
                    </CSVLink>
                  </div>
                </div>
                {this.state.uploadedVehicles.length > 0 ? (
                  <Table1
                    rows={this.state.uploadedVehicles || []}
                    disableHead
                    // allUsersId={this.props.allUsersId}
                    // showCheckbox
                    // handleChangeRowsPerPage={this.handleChangeRowsPerPage1}
                    // handleChangePage={this.handleChangePage1}
                    isChecked={this.props.isChecked}
                    translate={this.props.translate}
                    rowsPerPage={this.state.vehicleUploadPageSize}
                    handleChangeRowsPerPage={this.handleChangeRowsPerPageUpload}
                    handleChangePage={this.handleChangePageUpload}
                    page={this.state.vehicleUploadPage}
                    isEditable={false}
                    // ServerSetting={this.props.ServerSetting}
                    themecolors={this.props.themecolors}
                    // checkHandleChange={this.unitToUserpermission}
                    canAssign
                    canRemove
                    // setSerialNo
                    isCursoPointer
                    rowDefinition={
                      this.state.isVehicleStatus
                        ? [
                            {
                              id: "vehicleLicensePlate",
                              label: this.props.translate(
                                "vehicleLicensePlate",
                              ),
                            },
                            {
                              id: "vehicleStatus",
                              label: this.props.translate("status"),
                            },
                          ]
                        : this.props.ServerSetting.contractType === 2
                          ? [
                              {
                                id: "label",
                                label: this.props.translate("label"),
                              },
                              {
                                id: "category",
                                label: this.props.translate("vehicleType"),
                              },
                              {
                                id: "vehicleLicensePlate",
                                label: this.props.translate(
                                  "vehicleLicensePlate",
                                ),
                              },

                              {
                                id: "make",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("make"),
                              },
                              {
                                id: "model",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("model"),
                              },
                              {
                                id: "city",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("city"),
                              },
                              {
                                id: "category",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("category"),
                              },
                              {
                                id: "capacity",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("capacity"),
                              },
                              {
                                id: "vin",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("vin"),
                              },
                              {
                                id: "garage",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("garage"),
                              },
                              {
                                id: "deliveryDate",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("deliveryDate"),
                              },
                              {
                                id: "leaseStartDate",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("leaseStartDate"),
                              },
                              {
                                id: "leaseEndDate",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("leaseEndDate"),
                              },
                            ]
                          : [
                              {
                                id: "label",
                                label: this.props.translate("label"),
                              },
                              {
                                id: "category",
                                label: this.props.translate("vehicleType"),
                              },
                              {
                                id: "vehicleLicensePlate",
                                label: this.props.translate(
                                  "vehicleLicensePlate",
                                ),
                              },

                              {
                                id: "make",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("make"),
                              },
                              {
                                id: "model",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("model"),
                              },
                              {
                                id: "city",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("city"),
                              },
                              {
                                id: "category",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("category"),
                              },
                              {
                                id: "capacity",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("capacity"),
                              },

                              {
                                id: "vin",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("vin"),
                              },
                              {
                                id: "garage",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("garage"),
                              },
                              {
                                id: "reason",
                                numeric: false,
                                disablePadding: false,
                                label: this.props.translate("Reason"),
                              },
                            ]
                    }
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {this.props.translate("nodataFound")}
                  </div>
                )}
              </>
            )}
            {/* : "All Vehicles are Valid"} */}
          </CustomDialog>
        )}

        {this.state.showVinConfirmDialog && (
          <ConfirmDialoag
            onCancel={this.handleVinConfirmNo}
            onOk={this.handleVinConfirmYes}
            title="vinDecoderDataFound"
            CancelText="no"
            OkText="yes"
          >
            <p style={{ margin: 0 }}>
              {this.props.translate("vinDecoderDataFoundMessage")}
            </p>
            {this.getVinConfirmPreview() && (
              <p style={{ margin: "8px 0 0", fontWeight: 600 }}>
                {this.getVinConfirmPreview()}
              </p>
            )}
            {this.getVinConfirmDetails()}
          </ConfirmDialoag>
        )}

        {this.state.mulkiyaVehicle && (
          <MulkiyaModal
            vehicle={this.state.mulkiyaVehicle}
            onClose={this.closeMulkiya}
            translate={this.props.translate}
            autoPrint={this.state.mulkiyaAutoPrint}
          />
        )}

        {this.state.onDeleteConfirmation && (
          <>
            <ConfirmDialoag
              onCancel={this.onCancel}
              onOk={this.deleteVehicle}
              title={this.props.translate("areYouWantToDelete")}
              children={this.state.selectedVehicle.label}
            />
          </>
        )}

        {this.state.onDataSendConfirmation && (
          <>
            <ConfirmDialoag
              onCancel={this.onVehicleSendDataCancel}
              onOk={this.onVehicleSendData}
              title={this.props.translate("Are You Want To Sync With Servers")}
              children={this.state.selectedVehicle.label}
            />
          </>
        )}
        {this.state.showHistoryVehicles && (
          <>
            <ConfirmDialoag
              onCancel={this.handleCancelShowVehicleHistory}
              onOk={this.handleCancelShowVehicleHistory}
              title={this.props.translate("Vehicle History")}
              maxWidth={false}
              PaperProps={{
                style: {
                  width: "800px",
                  maxWidth: "90vw",
                  padding: "20px",
                },
              }}
              children={
                <div style={{ width: "800px", maxWidth: "800px" }}>
                  {this.state.vehicleHistoryLoader ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <CircularProgress color="success" />
                    </div>
                  ) : this.state.vehicleHistoryData?.data?.length > 0 ? (
                    <Table
                      rows={
                        Array.isArray(this.state.vehicleHistoryData)
                          ? this.state.vehicleHistoryData
                          : this.state.vehicleHistoryData?.data || []
                      }
                      pagination={this.setPaginationVehiclHistory()}
                      handleChangePage={this.handleChangePageVehicleHistory}
                      handleChangeRowsPerPage={
                        this.handleChangePerPageVehicleHistory
                      }
                      translate={this.props.translate}
                      rowsPerPage={this.state.vehicleHistoryPageSize}
                      themecolors={this.props.themecolors}
                      vehicleHistoryTable
                      rowDefinition={[
                        {
                          id: "attributes.userName",
                          numeric: false,
                          disablePadding: false,
                          label: this.props.translate("userName"),
                        },
                        {
                          id: "oldContractNumber",
                          numeric: false,
                          disablePadding: false,
                          label: this.props.translate("contractNumber"),
                        },
                        {
                          id: "created",
                          numeric: false,
                          disablePadding: false,
                          label: this.props.translate("createdDate"),
                        },
                      ]}
                    />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontWeight: 500,
                      }}
                    >
                      {this.props.translate("nodataFound")}
                    </div>
                  )}
                </div>
              }
            />
          </>
        )}

        {isVehicleDnsModalOpen && (
          <ConfirmDialoag
            onCancel={this.handleCloseVehicleDnsModal}
            onOk={this.handleCloseVehicleDnsModal}
            title={this.props.translate("vehicleDeliveryNotes")}
            maxWidth={"lg"}
          >
            <div>
              {isLoadingVehicleDns ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <CircularProgress color="success" />
                </div>
              ) : vehicleDns?.data?.length > 0 ? (
                <Table
                  rows={vehicleDns?.data || []}
                  pagination={this.getPaginationForVehicleDns()}
                  handleChangePage={this.handleVehicleDnsPageChange}
                  handleChangeRowsPerPage={this.handleVehicleDnsPageSizeChange}
                  translate={this.props.translate}
                  timezone={
                    this.props.logInUser?.attributes?.timezone || "Asia/Riyadh"
                  }
                  rowsPerPage={vehicleDns?.pageSize}
                  themecolors={this.props.themecolors}
                  vehicleHistoryTable
                  rowDefinition={[
                    {
                      id: "deliveryNoteNumber",
                      numeric: false,
                      disablePadding: false,
                      label: translate("deliveryNoteNumber"),
                    },
                    {
                      id: "deliveryNoteRefNumber",
                      numeric: false,
                      disablePadding: false,
                      label: translate("deliveryNoteRefNumber"),
                    },
                    {
                      id: "created",
                      numeric: false,
                      disablePadding: false,
                      label: translate("created"),
                    },

                    {
                      id: "saleNetAmount",
                      numeric: false,
                      disablePadding: false,
                      label: translate("Total Amount"),
                    },
                    {
                      id: "viewArchivedDns",
                      numeric: false,
                      disablePadding: false,
                      label: translate("View"),
                    },
                  ]}
                />
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "gray",
                    fontWeight: 500,
                  }}
                >
                  {translate("nodataFound")}
                </div>
              )}
            </div>
          </ConfirmDialoag>
        )}
        {/* {Array.isArray(this.state.vehicleHistoryData) && this.state.vehicleHistoryData.length > 0 ? (
  <Table
    rows={this.state.vehicleHistoryData}
    pagination={this.setPaginationVehiclHistory()}
    handleChangePage={this.handleChangePageVehicleHistory}
    handleChangeRowsPerPage={this.handleChangePerPageVehicleHistory}
    translate={this.props.translate}
    rowsPerPage={this.state.vehicleHistoryPageSize}
    themecolors={this.props.themecolors}
    rowDefinition={[
      {
        id: "attributes.userName",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("userName"),
      },
      {
        id: "oldContractNumber",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("contractNumber"),
      },
      {
        id: "created",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("createdDate"),
      },
    ]}
  />
) : (
 <>
{this.state.showHistoryVehicles&&
    <div style={{ textAlign: "center", padding: "20px", fontSize: "16px", color: "#888" }}>
    No Data Available
  </div>
}
 </>
)} */}
      </div>
    );
  }
}
const mapState = (state) => {
  const devices = {
    ...state.devices,
    data:
      state.devices.data &&
      state.devices.data.map((d) => {
        if (d.created) {
          if (state.logInUsers.twelveHourFormat) {
            d.created = moment(d.created).format("YYYY-MM-DD hh:mm A");
          } else {
            d.created = moment(d.created).format("YYYY-MM-DD HH:mm");
          }
          return d;
        } else {
          return d;
        }
      }),
  };

  return {
    devices: state.devices,
    logInUser: state.logInUsers,
    group: state.groups,
    cities: state.Cities.cities,
    themecolors: state.themecolors,
    ServerSetting: state.ServerSetting,
    cities: state.Cities.cities,
    parentUnitLimits: state.parentUnitLimits,
    userCities: state.Cities.userCities,
  };
};

const mapStateToProps = connect(mapState);
export const VehicleList = mapStateToProps(vehicleList);
const vehicleHeaders = [
  { label: "Label", key: "label" },
  { label: "Vehicle Type", key: "category" },
  { label: "License Plate", key: "vehicleLicensePlate" },
  { label: "Make", key: "make" },
  { label: "Model", key: "model" },
  { label: "Capacity", key: "capacity" },
  { label: "VIN", key: "vin" },
  { label: "Garage", key: "garage" },
  { label: "Reason", key: "reason" },
];
